import { useRef } from 'react';

import { useDiscardChangesGuard } from '@/shared/lib/use-discard-changes-guard';
import { useSheetStore } from '@/shared/stores/sheet-store';
import { SheetBreadcrumb } from '@/shared/ui/panels/sheet-breadcrumb';
import {
    SheetCloseButton,
    SheetDescription,
    SheetHeader,
    SheetPanel,
    SheetTitle,
} from '@/shared/ui/panels/sheet-panel';

import { useAddClientContactSheet } from '../model/use-add-client-contact-sheet';
import { AddClientContactForm } from './add-client-contact/add-client-contact-form';

export function AddClientContact() {
    const closeCurrentSheet = useSheetStore((state) => state.closeCurrentSheet);

    const opening = useAddClientContactSheet();

    // Add contact leaves the chart interactive during a save (unlike edit profile), so the sheet can
    // be reopened mid-save; only the mounted form knows whether its own save is pending.
    const isSavingRef = useRef(false);

    const { confirmDiscardChanges, setDirty } = useDiscardChangesGuard(() => isSavingRef.current);

    const handleClose = () => confirmDiscardChanges(() => closeCurrentSheet());

    return (
        <SheetPanel
            type="clients/add-contact"
            side="right"
            size="medium"
            showCloseButton={false}
            onRequestClose={handleClose}
        >
            <SheetHeader variant="breadcrumbs">
                <SheetBreadcrumb onNavigate={confirmDiscardChanges} />
                <SheetCloseButton onClick={handleClose} className="ml-auto shrink-0" />
            </SheetHeader>
            {opening && (
                <AddClientContactForm
                    key={opening.openingId}
                    clientId={opening.id}
                    onDirtyChange={setDirty}
                    onPendingChange={(isPending) => {
                        isSavingRef.current = isPending;
                    }}
                >
                    <div className="px-4 pt-4">
                        <SheetTitle className="font-bold">Add contact</SheetTitle>
                        <SheetDescription className="sr-only">
                            Add a contact for {opening.name}.
                        </SheetDescription>
                    </div>
                </AddClientContactForm>
            )}
        </SheetPanel>
    );
}
